import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

import { useSelector } from 'react-redux';

import {
    Menu,
} from "antd";

import navigationNone from "../../../../navigation/vertical";
import navigationSupplier from "../../../../navigation/vertical-supplier";
import navigationPartner from "../../../../navigation/vertical-partner";
import navigationAdmin from "../../../../navigation/vertical-admin";
import navigationReviewer from "../../../../navigation/vertical-reviewer";
import navigationPowerUser from "../../../../navigation/vertical-poweruser";

const { SubMenu } = Menu;

const navs = {
  Proveedor: navigationSupplier,
  Revisor: navigationReviewer,
  Colaborador: navigationPartner,
  Administrador: navigationAdmin,
  PowerUser: navigationPowerUser,
};

// Encuentra el item activo (y los submenús a abrir) comparando la URL actual
// —incluyendo el query string— contra los navLink. Primero intenta coincidencia
// exacta (path+query, para distinguir links con misma ruta y distinto query,
// p.ej. records?stage=done vs records?stage=unfinish); si no hay, cae a comparar
// solo la ruta.
const findActive = (navigation, fullUrl, pathname) => {
  let pathFallback = null;

  const check = (navLink, selectedKey, openKeys) => {
    if (navLink === fullUrl) return { selectedKey, openKeys };
    if (!pathFallback && navLink.split("?")[0] === pathname) {
      pathFallback = { selectedKey, openKeys };
    }
    return null;
  };

  for (const item of navigation || []) {
    if (item.items) {
      for (const child of item.items) {
        if (!child.items) {
          const hit = child.navLink && check(child.navLink, child.id, [item.id]);
          if (hit) return hit;
        } else {
          for (const gchild of child.items) {
            const hit =
              gchild.navLink &&
              check(gchild.navLink, gchild.id, [item.id, child.id]);
            if (hit) return hit;
          }
        }
      }
    } else if (item.navLink) {
      const hit = check(item.navLink, item.id, []);
      if (hit) return hit;
    }
  }

  return pathFallback || { selectedKey: null, openKeys: [] };
};

export default function MenuItem(props) {
    const [menuItems, setmenuItems] = useState([]);
    const { onClose } = props;

    // Redux
    const customise = useSelector(state => state.customise)
    const user = useSelector((state) => state.user);

    // Location
    const location = useLocation();
    const { pathname } = location;
    const fullUrl = pathname + location.search;

    const role = user.roles[0];
    const navigation = navs[role] ?? navigationNone;

    // Item activo + submenús a abrir, recalculado en cada navegación.
    const { selectedKey, openKeys: activeOpenKeys } = findActive(
      navigation,
      fullUrl,
      pathname
    );

    // openKeys controlado: arranca con el submenú activo y se fusiona con lo que
    // el usuario abra/cierre manualmente (onOpenChange).
    const [openKeys, setOpenKeys] = useState(activeOpenKeys);

    useEffect(() => {
      if (activeOpenKeys.length) {
        setOpenKeys((prev) =>
          Array.from(new Set([...prev, ...activeOpenKeys]))
        );
      }
    }, [fullUrl, role]);

    useEffect(() => {
        setmenuItems(
          navigation.map((item, index) => {
            if (item.header) {
              return (
                <Menu.ItemGroup
                  key={index}
                  title={item.header}
                ></Menu.ItemGroup>
              );
            }

            if (item.items) {
              return (
                <SubMenu key={item.id} icon={item.icon} title={item.title}>
                  {item.items.map((childrens) => {
                    if (!childrens.items) {
                      return (
                        // Level 2
                        <Menu.Item key={childrens.id} onClick={onClose}>
                          <Link to={childrens.navLink}>{childrens.title}</Link>
                        </Menu.Item>
                      );
                    } else {
                      return (
                        // Level 3
                        <SubMenu key={childrens.id} title={childrens.title}>
                          {childrens.items.map((childItem) => {
                            return (
                              <Menu.Item key={childItem.id} onClick={onClose}>
                                <Link to={childItem.navLink}>
                                  {childItem.title}
                                </Link>
                              </Menu.Item>
                            );
                          })}
                        </SubMenu>
                      );
                    }
                  })}
                </SubMenu>
              );
            } else {
              return (
                // Level 1
                <Menu.Item key={item.id} icon={item.icon} onClick={onClose}>
                  <Link to={item.navLink}>{item.title}</Link>
                </Menu.Item>
              );
            }
          })
        );
    }, [role]);

    return (
        <Menu
            mode="inline"
            selectedKeys={selectedKey ? [selectedKey] : []}
            openKeys={openKeys}
            onOpenChange={setOpenKeys}
            theme={customise.theme == "light" ? "light" : "dark"}
        >
            {menuItems}
        </Menu>
    );
};
